import { getAccessTokenClient } from '@/src/lib/auth/requests/get-access-token.client';
import { success, failure } from '@/src/lib/http/business/server-action-results';

export async function getAccessToken() {
  try {
    const accessToken = await getAccessTokenClient();
    return success(accessToken);
  } catch (error) {
    return failure(error);
  }
}
